import { theme } from '@lib/style/theme';
import { unit } from '@lib/style/unit';
import { FontType } from '@packages/style/fonts';
import { ThemeConfiguration } from '@packages/style/themes';
import { lighten } from 'polished';
import { createGlobalStyle } from 'styled-components';

const f = (theme: ThemeConfiguration): FontType => theme.fonts.primary;

export const GlobalStyle = createGlobalStyle`
    *, .box-sizing, body, html {
        &, &:after, &:before {
            box-sizing: border-box;
            background-clip: padding-box;
        }
    }
    a {
        color: ${theme('colors.primary')};
        text-decoration: none;
        transition: color 200ms;
        cursor: pointer;
        &:not([role="button"]):not(.MuiListItem-root) {
            &:hover {
                color: ${theme('colors.primary', (c) => (c && c !== 'transparent' ? lighten(0.1, c) : c))};
            }
        }
    }

    .widget-app-container {
        pointer-events: none !important;
    }

    .widget-app-container > * {
        pointer-events: all !important;
    }

    img {
        border: none;
    }

    html, body, #root, #__next{
        min-height: 100vh;
        width: 100%;
        border: none;
    }

    #root, #__next {
        display: flex;
        transition: padding 200ms;
    }

    body {
        margin: 0;
        padding: 0;
        font-family: ${({ theme }) => `'${f(theme as any).font}', ${f(theme as any).fallback}`};
        font-size: ${({ theme }) => unit(f(theme as any).size)};
    }

    .hidden {
        display: none !important;
    }

    .notify__container {
        bottom: 114px !important;
        z-index: 21474 !important;
    }

    #hubspot-messages-iframe-container {
        @media screen and (max-width: 767px) {
            display: none;
        }
    }
    /*** iPhone and iOS Form Input Zoom Fixes ***/
    /* Fix Input Zoom on devices older than iPhone 5: */
    @media screen and (device-aspect-ratio: 2/3) {
        select, textarea, input[type="text"], input[type="password"],
        input[type="datetime"], input[type="datetime-local"],
        input[type="date"], input[type="month"], input[type="time"],
        input[type="week"], input[type="number"], input[type="email"],
        input[type="url"]{ font-size: 16px; }
    }

    /* Fix Input Zoom on iPhone 5, 5C, 5S, iPod Touch 5g */
    @media screen and (device-aspect-ratio: 40/71) {
        select, textarea, input[type="text"], input[type="password"],
        input[type="datetime"], input[type="datetime-local"],
        input[type="date"], input[type="month"], input[type="time"],
        input[type="week"], input[type="number"], input[type="email"],
        input[type="url"]{ font-size: 16px; }
    }

    /* Fix Input Zoom on iPhone 6, iPhone 6s, iPhone 7  */
    @media screen and (device-aspect-ratio: 375/667) {
        select, textarea, input[type="text"], input[type="password"],
        input[type="datetime"], input[type="datetime-local"],
        input[type="date"], input[type="month"], input[type="time"],
        input[type="week"], input[type="number"], input[type="email"], 
        input[type="tel"], input[type="url"]{ font-size: 16px; }
    }

    /* Fix Input Zoom on iPhone 6 Plus, iPhone 6s Plus, iPhone 7 Plus, iPhone 8, iPhone X, XS, XS Max  */
    @media screen and (device-aspect-ratio: 9/16) {
        select, textarea, input[type="text"], input[type="password"],
        input[type="datetime"], input[type="datetime-local"],
        input[type="date"], input[type="month"], input[type="time"],
        input[type="week"], input[type="number"], input[type="email"],
        input[type="tel"], input[type="url"]{ font-size: 16px; }
    }
    .product-view-pricing label {
        font-size: 11px !important;
    }
    .product-view-pricing .MuiGrid-item {
        padding-left: 0px !important;
        padding-right: 5px !important;
    }
    .product-view-pricing .MuiInputBase-root input {
        padding-right: 0px !important;
        padding-left: 5px !important;
    }
    .product-view-pricing .MuiOutlinedInput-adornedStart {
        padding-right: 0px !important;
        padding-left: 0px !important;
    }
`;
